import fetch from '../config/api'

/**
 * 科普知识或者修复成果列表
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {type} 1表示科普知识
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */
const knowledgeList = (language = '1', type = '1', num = '0', take = '10') => fetch('/knowledge/index', {
    p: 'wx',
    language,
    type,
    skip: num * take, //从第几个开始
    take //取几条数据
});

/**
 * 获取知识详情
 */
const knowledgeDetail = (language = '1', knowledge_id) => fetch('/knowledge/detail', {
    p: 'wx',
    language,
    knowledge_id,
});

/**
 * 科普知识或者修复成果列表
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */
const ExhibitRepair = (language = '1', num = '0', take = '10') => fetch('/volunteer/exhibit_repair', {
    p: 'wx',
    language,
    skip: num * take, //从第几个开始
    take //取几条数据
});

export default {
    knowledgeList,
    knowledgeDetail,
    ExhibitRepair
}